// トップスライダーの起動
jQuery(function ($) {
  if ($("#slider").length > 0) {
    // カルーセルスライダーの設定
    var options = {
      autoplay: true,
      arrows: true,
      infinite: true,
      autoplaySpeed: 4000, //　スライダー表示時間
      speed: 1000, // スライド変化時間
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      centerMode: true,
      centerPadding: "15%",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 390,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    };
    $("#slider").slick(options);
  }
});

// アーティストスライダーの起動
jQuery(function ($) {
  if ($("#js-artist-slick").length > 0) {
    // カルーセルスライダーの設定
    var width = $(window).width();

    if (width <= 568) {
      var options = {
        autoplay: true,
        arrows: true,
        infinite: true,
        autoplaySpeed: 4000, //　スライダー表示時間
        speed: 1000, // スライド変化時間
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        // variableWidth: true,
      };
      $("#js-artist-slick").slick(options);
    }
  }
});
